<template>
  <div class="chart-container">
    <div
      class="chart-wrapper"
      v-for="(item, index) in chartData.xAxis"
      :key="index"
      ref="chart"
    ></div><dv-decoration-6 style="width:300px;height:30px;" />
  </div>
</template>

<script>
// 注意：在Vue项目中需要先安装echarts: npm install echarts
import * as echarts from 'echarts'

export default {
  name: 'DeviceStatusChart',
  data() {
    return {
      chartData: {
        value: 24.2,
        text: '-',
        color: ['rgba(36, 209, 209, 1)', 'rgba(252, 142, 108, 1)', 'rgba(68, 163, 252, 1)', 'rgba(165, 211, 255, 1)'],
        xAxis: ['开阀数量', '关阀数量', '无阀门数量', '阀异常数量'],
        values: ['76', '78', '22', '33']
      },
      myChart: null
    }
  },
  computed: {
    chartOption() {
      let seriesData = []
      let titleData = []
      
      this.chartData.values.forEach((item, index) => {
        titleData.push({
          text: '台' + '\n\n\n\n',
          left: 22 * (index + 1) - 0.5 + '%',
          top: '52%',
          textAlign: 'center',
          textStyle: {
            fontSize: '12',
            color: 'rgba(255,255,255,0.5)',
            fontWeight: '400',
          },
          subtext: this.chartData.xAxis[index],
          subtextStyle: {
            fontSize: '16',
            color: 'rgba(255,255,255,0.5)',
            fontWeight: '400',
          },
        })
        
        seriesData.push({
          type: 'pie',
          radius: ['65', '68'],
          center: [22 * (index + 1) + '%', '50%'],
          hoverAnimation: false,
          label: {
            normal: {
              position: 'center'
            },
          },
          data: [
            {
              value: item,
              name: this.chartData.text,
              itemStyle: {
                normal: {
                  color: this.chartData.color[index],
                }
              },
              label: {
                normal: {
                  show: false,
                }
              }
            },
            {
              value: 100 - item,
              name: '占位',
              tooltip: {
                show: false
              },
              itemStyle: {
                normal: {
                  color: '#edf1f4',
                }
              },
              label: {
                normal: {
                  formatter: item,
                  textStyle: {
                    fontSize: 36,
                    color: 'rgba(255,255,255,1)',
                  }
                },
              }
            }
          ]
        })
      })
      
      return {
        backgroundColor: 'rgba(2,22,48,1)',
        title: titleData,
        series: seriesData,
        grid: {
          top: "30px",
          left: "45px",
          right: "0",
          bottom: "39px"
        }
      }
    }
  },
  mounted() {
  this.myCharts = []
  this.$nextTick(() => {
    this.chartData.xAxis.forEach((item, index) => {
      const chartDom = this.$refs.chart[index]
      if (chartDom) {
        const chart = echarts.init(chartDom)
        chart.setOption(this.getSingleChartOption(index))
        this.myCharts.push(chart)
      }
    })
    window.addEventListener('resize', this.handleResize)
  })
},
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize)
    if (this.myChart) {
      this.myChart.dispose()
    }
  },
  methods: {
  getSingleChartOption(index) {
    // 只渲染当前index的图表
    return {
    //   backgroundColor: 'rgba(2,22,48,1)',transparent// 透明背景
      title: {
        text: '台\n\n\n\n',
        left: '50%',
        top: '52%',
        textAlign: 'center',
        textStyle: {
          fontSize: '12',
          color: 'rgba(255,255,255,0.5)',
          fontWeight: '400',
        },
        subtext: this.chartData.xAxis[index],
        subtextStyle: {
          fontSize: '16',
          color: 'rgba(255,255,255,0.5)',
          fontWeight: '400',
        },
      },
      series: [
        {
          type: 'pie',
          radius: ['65', '68'],
          center: ['50%', '50%'],
          hoverAnimation: false,
          label: { normal: { position: 'center' } },
          data: [
            {
              value: this.chartData.values[index],
              name: this.chartData.text,
              itemStyle: { normal: { color: this.chartData.color[index] } },
              label: { normal: { show: false } }
            },
            {
              value: 100 - this.chartData.values[index],
              name: '占位',
              tooltip: { show: false },
              itemStyle: { normal: { color: '#edf1f4' } },
              label: {
                normal: {
                  formatter: this.chartData.values[index],
                  textStyle: {
                    fontSize: 36,
                    color: 'rgba(255,255,255,1)',
                  }
                }
              }
            }
          ]
        }
      ]
    }
  },
  handleResize() {
    if (this.myCharts) {
      this.myCharts.forEach(chart => chart.resize())
    }
  },
  // 其它方法...
}
}
</script>

<style lang="less" scoped>
.header {
  text-align: center;
  margin-bottom: 40px;
  padding: 20px;
  
  h1 {
    font-size: 32px;
    margin-bottom: 10px;
    background: linear-gradient(90deg, #24d1d1, #44a3fc);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    text-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
  }
  
  p {
    color: #8ca0d7;
    font-size: 16px;
    max-width: 600px;
    margin: 0 auto;
    line-height: 1.6;
  }
}

.chart-container {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 4px;
}

.chart-wrapper {
  flex: 1 1 180px;
  max-width: 200px;
  min-width: 140px;
  height: 220px;           // 固定高度，图表会变小
//   background: rgba(8, 30, 60, 0.5);
  border-radius: 12px;
  box-shadow: 0 6px 18px rgba(0, 20, 80, 0.2);
  padding: 8px;            // 内边距也缩小
//   border: 1px solid rgba(100, 150, 255, 0.15);
  box-sizing: border-box;
  margin-bottom: 16px;
}

.data-info {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  gap: 20px;
  margin-top: 20px;
}

.data-item {
  background: rgba(20, 40, 80, 0.5);
  padding: 12px 20px;
  border-radius: 8px;
  font-size: 16px;
  display: flex;
  align-items: center;
  border: 1px solid rgba(100, 150, 255, 0.2);
}

.color-indicator {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  margin-right: 10px;
}

.controls {
  display: flex;
  justify-content: center;
  gap: 15px;
  margin-top: 20px;
}

.control-btn {
  background: rgba(30, 60, 120, 0.7);
  border: 1px solid rgba(100, 150, 255, 0.3);
  color: #b3ccf8;
  padding: 8px 16px;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.3s ease;
  font-size: 14px;
  
  &:hover {
    background: rgba(50, 100, 200, 0.7);
    transform: translateY(-2px);
    box-shadow: 0 5px 15px rgba(0, 50, 150, 0.3);
  }
}
@media (max-width: 900px) {
  .chart-wrapper {
   width: 100%;
    min-width: 0;
  }
}
// @media (max-width: 768px) {
//   .chart-wrapper {
//     height: 350px;
//     padding: 15px;
//   }
  
//   .header h1 {
//     font-size: 26px;
//   }
  
//   .data-item {
//     font-size: 14px;
//     padding: 10px 15px;
//   }
// }
</style>